const axios = require('axios');
module.exports.init = me => {
  me.searchWorkshops = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/workshops/instances/search`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response.message);
    });
  };
  me.registerInWorkshop = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json',
      'Authorization': `Bearer ${me.access_token}`
    };
    axios.post(`${me.config.url}/workshops/register/submit`, formData, {
      headers: me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.orderWorkshop = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    };
    axios.post(`${me.config.url}/workshops/orders/store`, formData, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.showRegisteredWorkshop = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    };
    axios.post(`${me.config.url}/workshops/register/show/${data.id}`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.generatePaymentLink = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    };
    axios.post(`${me.config.url}/workshops/register/pay-link/${data.id}`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.cancelRegisteration = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    };
    axios.post(`${me.config.url}/workshops/register/cancel/${data.id}`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};